import { useCallback, useEffect, useMemo } from 'react';
import { formatMoney, type MonedaDeEmpresa } from '@/lib/utils/moneda';
import { useConfiguracionDelModulo } from '../store/configuracion-del-modulo-store';

/**
 * L7 (vault 279): la moneda de la empresa para un componente. Re-dibuja cuando llega
 * la configuración, así ningún monto queda con el formato de antes de cargar.
 *
 * Revisión T11-T12: `moneda` y `formatear` con identidad estable entre renders
 * (van en dependencias de efectos), y `cargada` también cuando falló el pedido:
 * montos sin símbolo, nunca esqueleto infinito.
 */
export function useMonedaDeLaEmpresa(): {
  moneda: MonedaDeEmpresa | null;
  formatear: (v: number | null | undefined, decimales?: number) => string;
  cargada: boolean;
} {
  const ajustes = useConfiguracionDelModulo((s) => s.ajustes);
  const error = useConfiguracionDelModulo((s) => s.error);
  const cargarAjustes = useConfiguracionDelModulo((s) => s.cargarAjustes);
  useEffect(() => {
    cargarAjustes();
  }, [cargarAjustes]);
  const base = ajustes?.baseCurrency ?? null;
  const moneda = useMemo(
    () => (base ? { code: base.code, symbol: base.symbol } : null),
    [base?.code, base?.symbol]
  );
  const formatear = useCallback(
    (v: number | null | undefined, decimales = 2) => formatMoney(v, moneda, decimales),
    [moneda]
  );
  return { moneda, formatear, cargada: ajustes !== null || error !== null };
}
